import { Injectable } from '@angular/core';
import { RequestOptions, Headers, Http } from '@angular/http';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { AppAuthHttpService } from 'app/http/app.auth.http.service';
import { ResponseUtilService } from 'app/shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EventCollisionService {

  private matchingUrl: string =
    this.environment.baseUrl + '/api/event-matches/matching';
  private mergeMachingUrl: string =
    this.environment.baseUrl + '/api/event-matches/merge-matching';
  private cancelMatchingUrl: string = this.environment.baseUrl + '/api/event-matches/cancel';
  private createNewMatchingUrl: string = this.environment.baseUrl + '/api/event-matches/createnew';
  private unmatchEventUrl: string =
    this.environment.baseUrl + '/api/event-matches/unmatch';


  constructor(
    private http: AppAuthHttpService,
    private environment: EnvironmentConfiguration,
    private responseUtilService: ResponseUtilService
  ) {}

  private get jsonOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return options;
  }

  getEventCollisionPropertyMatches(event_info: any): Observable<any> {
    return this.http
      .put(this.matchingUrl, JSON.stringify({ event_info }), this.jsonOptions)
      .map((response) => response.json())
      .catch((response) => this.responseUtilService.handleError(response))
      .share();
  }

  updateEventCollisionMatch(event_info: any): Observable<any> {
    return this.http
      .put(
        this.mergeMachingUrl,
        JSON.stringify( event_info ),
        this.jsonOptions
      )
      .map((response) => response.json())
      .catch((response) => this.responseUtilService.handleError(response))
      .share();
  }

  cancelEventCollisionMatch(matchesToCancel: number[]) {
    return this.http.put(`${this.cancelMatchingUrl}`, JSON.stringify( matchesToCancel ), this.jsonOptions)
      .catch((response) => this.responseUtilService.handleError(response))
      .share();
  }

  createNewEventCollisionMatch(eventMatchId: number) {
    return this.http.put(`${this.createNewMatchingUrl}/${eventMatchId}`, null, null)
      .catch((response) => this.responseUtilService.handleError(response))
      .share();
  }

  unmatchEvent(unmatchInfo: any): Observable<any> {
    return this.http
      .post(
        this.unmatchEventUrl,
        JSON.stringify( unmatchInfo ),
        this.jsonOptions
      )
      .map((response) => response.json())
      .catch((response) => this.responseUtilService.handleError(response))
      .share();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-collision/event-collision.service.ts